import { render, staticRenderFns } from "./HeaderImageManagement.vue?vue&type=template&id=2dd6c2cc&scoped=true"
import script from "./HeaderImageManagement.vue?vue&type=script&lang=js"
export * from "./HeaderImageManagement.vue?vue&type=script&lang=js"
import style0 from "./HeaderImageManagement.vue?vue&type=style&index=0&id=2dd6c2cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd6c2cc",
  null
  
)

export default component.exports